'use strict';

/**
 * Directive: Confirm
 *
 * @version 12.4.0 #756 MLIBJS-121 Add validation to export ngReallyClick for ES6 usage
 *          8.3.0 #587 Add missing directives, Improve `filterSearch`
 * 
 * @author Ryan Sweeney <rsweeney@webduct.com>
 * @author Erik Orozco <eorozco@intersog.com>
 * @copyright   (c) 2017-2020 Build Centrix
 */
var ngReallyClick = angular.module('wd.directives.confirm', [])
    .directive('ngReallyClick', function($uibModal) {

        var $timestamp = new Date().getTime();

        return {
            restrict: 'A',
            scope: {
                ngReallyClick:'&'
            },
            link: function(scope, element, attrs) {
                element.bind('click', function() {

                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        // This is the only path which seems to work in relation to main library
                        templateUrl: './bower_components/main-library-js/lib/angularjs/directives/confirmation/wdConfirm.html?' + $timestamp,
                        controller: ['$scope', '$uibModalInstance', function ($scope, $uibModalInstance)
                        {

                            $scope.title = attrs.ngReallyTitle ? attrs.ngReallyTitle : 'Are you sure?';
                            $scope.message = attrs.ngReallyMessage ? attrs.ngReallyMessage : '';

                            $scope.ok = function() {
                                $uibModalInstance.close();
                            };

                            $scope.cancel = function() {
                                $uibModalInstance.dismiss('cancel');
                            };
                            
                        }]
                    });

                    modalInstance.result.then(function() {

                        scope.ngReallyClick();

                    }, function() {

                        //Modal dismissed

                    });

                });

            }

        };

    });
if (typeof module !== 'undefined' && module.exports) {
    module.exports = ngReallyClick;
}
//EOF